package one.healthium.settings.ui.meal_plan

import co.touchlab.kermit.Logger
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.catch
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.flow.onStart
import kotlinx.coroutines.flow.update
import one.healthium.meal_plans.domain.MealPlanRepository
import one.healthium.ui.common.message.UiMessage
import one.healthium.ui.common.message.UiMessageManager
import one.healthium.ui.common.vm.BaseViewModel

internal class MealPlanSettingsViewModel(
    private val mealPlanRepository: MealPlanRepository,
) : BaseViewModel() {
    private val _state = MutableStateFlow(MealPlanSettingsUiState())
    val state = _state.asStateFlow()

    val messages = UiMessageManager()

    init {
        combine(
            mealPlanRepository.getMealPlanInfos(),
            mealPlanRepository.getCurrentMealPlan()
        ) { mealPlans, currentMealPlan ->
            _state.update { state ->
                state.copy(
                    loading = false,
                    currentMealPlan = currentMealPlan,
                    mealPlans = mealPlans,
                )
            }
        }
            .onStart {
                _state.update { state ->
                    state.copy(loading = true)
                }
            }
            .catch {
                _state.update { state -> state.copy(loading = false) }
                messages.add(UiMessage.throwable(it))
            }
            .launch()
    }

    fun onMealPlanClicked(mealPlanUiModel: MealPlanUiModel) {
        launch {
            try {
                mealPlanRepository.setCurrentMealPlan(mealPlanUiModel.id)
            } catch (e: Exception) {
                Logger.e("failed to save current meal plan id", e)
                messages.add(UiMessage.throwable(e))
            }
        }
    }
}